import { useState } from "react";
import { DropdownOption, ListTableSort, SortOrder } from "sprint-common-web";

export interface RekognitionResultListingFilters {
    typeIds?: string[];
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: RekognitionResultListingFilters = {
    typeIds: [],
    sortBy: "startTimestamp",
    sortOrder: "asc"
};

export const useRekognitionResultListingFilters = () => {
    const [filters, setFilters] = useState<RekognitionResultListingFilters>(defaultFilters);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: RekognitionResultListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order
        }));
    };

    const setTypes = (options?: DropdownOption[]): void => {
        const typeIds = options?.map((option: DropdownOption) => option.key.toString());

        setTypeIds(typeIds);
    };

    const setTypeIds = (typeIds: string[] | undefined): void => {
        setFilters((prevFilters: RekognitionResultListingFilters) => ({ ...prevFilters, typeIds }));
    };

    return {
        filters,
        setTypes,
        setSort
    };
};
